export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const CURRENCIES = ['TRY', 'USD', 'EUR'];
export const money = (n, currency = 'TRY', digits = 0) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'TRY', maximumFractionDigits: digits }).format(n || 0);
export const trDate = (d) => (d ? d.split('-').reverse().join('.') : '—');
export const today = () => new Date().toISOString().slice(0, 10);
